import { customType } from 'drizzle-orm/pg-core'

// High precision numeric type for ratio and financial calculations.
export const numericAsHighPrecision = customType<{ data: number; driverData: string }>({
  dataType() {
    return 'numeric(18, 6)'
  },
  fromDriver(value: string): number {
    return parseFloat(value)
  },
  toDriver(value: number): string {
    return value.toString()
  },
})
